import { render, staticRenderFns } from "./BeforePostingChat.vue?vue&type=template&id=0dc85a8b&scoped=true&"
import script from "./BeforePostingChat.vue?vue&type=script&lang=js&"
export * from "./BeforePostingChat.vue?vue&type=script&lang=js&"
import style0 from "./BeforePostingChat.vue?vue&type=style&index=0&id=0dc85a8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc85a8b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRadioGroup,VRow,VTextField})
